import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import orderData from '../payouts.json'

import { PayoutPopup } from "../components/payouts-popup.component";
import { updateNestedValue } from "../../../../../../common/services/common.service";
import { MdTableView } from "react-icons/md";
import { selectSettlementPayoutCreatedItem, selectSettlementPayoutDeletedItem, selectSettlementPayoutsListItems, selectSettlementPayoutUpdatedItem } from "../../../../../../redux/settlement-hub/settlement-payouts/selector";
import { settlementPayouts } from "../../../../../../redux/settlement-hub/settlement-payouts/action";

const ManagementPayout = ({
  
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showPayoutPopup, setShowPayoutPopup] = useState<boolean>(false);
  const [showPayoutItemsPopup, setShowPayoutItemsPopup] = useState<boolean>(false);
  const [selectedPayout, setSelectedPayout] = useState<any>(
    {
      "order_id": "",
      "collector_app_id": "",
      "receiver_app_id": "",
      "Payout": {
        "Id": 0,
        "type": ""
      }
    }
  );

  const [listItems, setListItems] = useState<any>([]);
  const listOfPayoutsData = useSelector(selectSettlementPayoutsListItems)
  const createPayoutRequestsData = useSelector(selectSettlementPayoutCreatedItem)
  const updatePayoutRequestsData = useSelector(selectSettlementPayoutUpdatedItem)
  const deletePayoutsRequestsData = useSelector(selectSettlementPayoutDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'order_id', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'collector_app_id', headerName: 'Collector', sortable: true, filter: true, filterType: 'text', },
      { field: 'receiver_app_id', headerName: 'Receiver', sortable: true, filter: true, filterType: 'text', },
      { field: 'Payout.type', headerName: 'Type', sortable: true, filter: true, filterType: 'text', },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      // {field: '', headerName: 'Items', sortable: false, filter: false, cellRenderer: 'customFunctions'},

    ]);
  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedPayout, path, value', selectedPayout, path, value)
    const updatedData = updateNestedValue(selectedPayout, path, value)

    console.log('updatedData', updatedData)
    setSelectedPayout({...updatedData});
  }

  const handleAddPayout = () => {    
    setSelectedPayout({
      "order_id": "",
      "collector_app_id": "",
      "receiver_app_id": "",
      "PayoutRequest": {
        "Id": 0,
        "type": ""
      }
    })
    setShowPayoutPopup(true)
  }

  const handleInitiatePayout = () => {
    
  }

  const handleReconciliation = () => {

  }

  const handleEdit = (data: any) => {
    setSelectedPayout(data)
    setShowPayoutPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.PayoutRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(settlementPayouts.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/payouts/delete`,
      entity: 'settlementPayouts',
      jsonData: {
        Context:{},
        Records: [{Id: data?.PayoutRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Payout</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Payout',
      callback: () => handleAddPayout(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Initiate Payout</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   name: 'Initiate Payout',
    //   callback: () => handleInitiatePayout(),
    // },
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Initiate Reconciliation</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   name: 'Initiate Reconciliation',
    //   callback: () => handleReconciliation(),
    // }
  ];

  const handleReloadData = () => {
    listPayouts();
  }

  const handlePayoutItems =(item: any) => {
    setShowPayoutItemsPopup(true)
  }

  const customFunctions = [
    {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handlePayoutItems, title: "Show Payout Items"},
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  

  const listPayouts = async () => {
    console.log('settlementPayouts')
    await dispatch(settlementPayouts.resetAction({actionType:'list'}))
    await dispatch(settlementPayouts.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/payouts/list`,
      entity: 'settlementPayouts',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSavePayout = async (selectedPayout: any) => {
    if (selectedPayout?.Id > 0) {
      await dispatch(settlementPayouts.resetAction({actionType:'update'}))
      await dispatch(settlementPayouts.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/payouts`, entity: 'settlementPayouts', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedPayout
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(settlementPayouts.resetAction({actionType:'update'}))
      await dispatch(settlementPayouts.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/payouts`, entity: 'settlementPayouts', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedPayout
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listPayouts();
  }

  const closeModal = () => {
    setShowPayoutPopup(false)
  }

  const closeItemsModal = () => {
    setShowPayoutItemsPopup(false)
  }

  useEffect(() => {
    console.log('listOfPayoutsData', listOfPayoutsData)
    // if(listOfPayoutsData?.isSuccess){
      if(listOfPayoutsData?.result?.items && listOfPayoutsData?.result?.items?.length > 0)
      {
        console.log('listOfPayoutsData?.result?.items[0].Error', listOfPayoutsData?.result?.items[0].Error)
        if (listOfPayoutsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfPayoutsData?.result?.items)
        }     
      }  else {
        setListItems(orderData)
      }    
    // }
  }, [listOfPayoutsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listPayouts();
  }, [deletePayoutsRequestsData]);

  useEffect(() => {
    createColumnDefs()
    listPayouts()
  }, [pageData, pageSize])

  return (
    <>
      {
        showPayoutPopup ?
          <PayoutPopup
            selectedPayout={selectedPayout}
            closeModal={closeModal}
            handleSavePayout={handleSavePayout}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {/* {
        showPayoutItemsPopup ?
          <PayoutItemsPopup
            selectedPayout={selectedPayout}
            closeModal={closeItemsModal}
            handleSavePayout={handleSavePayout}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      } */}
      {listOfPayoutsData?.isLoading || deletePayoutsRequestsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfPayoutsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          headingName="Payouts" />
      }
    </>
  );
};

export default ManagementPayout;


